<template>
    <div>
      <div class="a-ui-tab__block" v-for="(criterion, idx) in expertCriteria">
        <div class="a-ui-tab__control-panel">
          <div class="a-ui-tab__control">
            <div class="a-ui-tab__arrow"></div>
            <div class="a-ui-tab__number-block">{{idx + 1}}</div>
            <div class="a-ui-tab__title">
              {{criterion.criterionName}}
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    props: {
      lot: Object
    },

    computed: {
      expertCriteria() {
        return this.lot.criteria.expert;
      }
    }
  }
</script>

<style scoped>

</style>
